import { FC, useState } from "react";
import { InputProps, Option } from "./InputProps";
import { SurveyPostObject } from "../../service/apiHelper";
import { OtherTextField } from "./OtherTextField";
export const CheckBox: FC<{
  id: string;
  label: string;
  handleChange: Function;
  values: Option[];
  setValues: Function;
  surveyLabel: string;
  surveyId: string;
  name: string;
  showTextBox: boolean;
}> = (props) => {
  const [checked, setChecked] = useState(false);
  const [otherValue, setOtherValue] = useState(""); //Updates the textbox

  const onOtherChange = (event: React.FormEvent<HTMLInputElement>) => {
    let parsedOtherValue = `${props.label} - ${event.currentTarget.value}`;
    setOtherValue(event.currentTarget.value);

    const _previousValues = [...props.values];
    const _newValues = _previousValues.filter(
      (value) => value.label !== props.label
    );
    _newValues.push({ label: props.label, value: parsedOtherValue });
    props.setValues(_newValues);

    let _survey: SurveyPostObject = {
      SurveyId: props.surveyId,
      SurveyLabel: props.surveyLabel,
      ResponseText: _newValues.map((label) => label.value).join("|"),
      ResponseValue: _newValues.map((label) => label.value).join("|"),
    };

    props.handleChange(_survey);
  };
  const checkBoxHandler = (event: React.FormEvent<HTMLInputElement>) => {
    setChecked(event.currentTarget.checked);

    if (event.currentTarget.checked) {
      let _newArray = [...props.values];
      _newArray.push({
        label: props.label,
        value: props.showTextBox ? otherValue : props.label,
      });
      props.setValues(_newArray);
      let _survey: SurveyPostObject = {
        SurveyId: props.surveyId,
        SurveyLabel: props.surveyLabel,
        ResponseText: _newArray.map((label) => label.value).join("|"),
        ResponseValue: _newArray.map((label) => label.value).join("|"),
      };

      props.handleChange(_survey);
    } else {
      //Updates the values the Inputs read from
      props.setValues(
        props.values.filter((value) => value.label !== props.label)
      );

      //Updates the survey response
      let _survey: SurveyPostObject = {
        SurveyId: props.surveyId,
        SurveyLabel: props.surveyLabel,
        ResponseText: props.values
          .filter((value) => value.label !== props.label)
          .map((label) => label.value)
          .join("|"),
        ResponseValue: props.values
          .filter((value) => value.label !== props.label)
          .map((label) => label.value)
          .join("|"),
      };
      props.handleChange(_survey);
    }
  };

  return (
    <div>
      <div className="relative flex items-start pt-2">
        <div className="flex items-center h-6">
          <input
            id={props.label}
            aria-describedby={props.label}
            name={props.name}
            checked={checked}
            onChange={checkBoxHandler}
            type="checkbox"
            className="w-4 h-4 border-gray-300 rounded text-primary-600 focus:ring-primary-600"
          />
        </div>
        <div className="leading-6">
          <label htmlFor={props.id} className="ml-3 text-sm text-gray-900">
            {props.label}
          </label>
        </div>
      </div>
      {props.showTextBox && checked && (
        <div className="ml-6 mt-1">
          <OtherTextField
            label={props.label}
            showError={false}
            errorLabel=""
            value={otherValue}
            setValue={setOtherValue}
            handleChange={onOtherChange}
          />
          {/* <p>{otherValue}</p>
          <p>{base}</p> */}
        </div>
      )}
    </div>
  );
};

export const CheckBoxSet: FC<{
  inputProps: InputProps;
  handleChange: Function;
}> = ({ inputProps, handleChange }) => {
  const [values, setValues] = useState<Option[]>([]);

  return (
    <fieldset>
      <p className="text-sm text-gray-900">
        {inputProps.label}{" "}
        {inputProps.required && <span className="text-error-600">*</span>}
      </p>
      {inputProps.options?.map((item, index) => (
        <CheckBox
          key={index}
          id={inputProps.id}
          name={item.label}
          label={item.label}
          handleChange={handleChange}
          setValues={setValues}
          values={values}
          surveyLabel={inputProps.label}
          surveyId={inputProps.id}
          showTextBox={item.showTextBox || false}
        />
      ))}
    </fieldset>
  );
};
